<template>
  <v-container class="step">
    <v-row  justify="center" class="full-height width-8">
      <v-col class="m2-container">
        <div class="m2-content">
          <p class="m2-content-title"
          data-aos='fade-down'
          data-aos-delay="150"
          data-aos-duration="2000"
          data-aos-mirror="true"
          data-aos-once="false"
          >{{$t('_material_1_txt_1')}}</p>
          <div class="m2-content-main">
            <p class="m2-content-txt-1"
            data-aos='fade-down'
            data-aos-delay="350"
            data-aos-duration="2000"
            data-aos-mirror="true"
            data-aos-once="false"
            >
            {{$t('_material_1_txt_2')}}
            </p>
            <br />
            <p class="m2-content-txt-2"
            data-aos='fade-down'
            data-aos-delay="550"
            data-aos-duration="2000"
            data-aos-mirror="true"
            data-aos-once="false"
            >
            {{$t('_material_1_txt_3')}}
            </p>
            <p class="m2-content-txt-2"
              data-aos='fade-down'
              data-aos-delay="550"
              data-aos-duration="2000"
              data-aos-mirror="true"
              data-aos-once="false"
            >
            {{$t('_material_2_txt_5')}}
            {{$t('_material_2_txt_6')}}
            {{$t('_material_2_txt_7')}}
            {{$t('_material_2_txt_8')}}
            {{$t('_material_2_txt_9')}}
            {{$t('_material_2_txt_10')}}
            {{$t('_material_2_txt_11')}}
            {{$t('_material_2_txt_12')}}
            {{$t('_material_2_txt_13')}}
            {{$t('_material_2_txt_14')}}
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style scoped>
.width-8 {
  padding-left: 10%;
  padding-right: 10%;
}
.m2-container {
  background-image: url("@/assets/image/renb_material_bg2.jpg");
  background-repeat: no-repeat, repeat;
  background-size: cover;
  background-position: center;
  height: 100%;
  width: 80%!important;
}
.m2-content {
  text-align: center;
  position: relative;
  height: 100%;
}
.m2-content-title {
  font-family: "BodoniModa-Bold";
  color: #8d2022;
  font-size: 28px;
  font-weight: 600;
  margin-top: 50px;
  white-space: pre-line;
}
.m2-content-txt-1 {
  color: #481807;
  font-family: "ZenKakuRegular";
  font-size: 13px;
  letter-spacing: 1.1px;
  line-height: 2;
  font-weight: 600;
}
.m2-content-txt-2 {
  color: #481807;
  font-family: "ZenKakuRegular";
  font-size: 13px;
  letter-spacing: 1.1px;
  line-height: 2;
  white-space: pre-line;
  font-weight: 600;
}
.m2-content-main {
  width: 80%;
  position: absolute;
  bottom: 15%;
  text-align: center;
  left: 10%;
}
@media (max-width: 960px) {
  .step {
    height: unset!important;
    scroll-snap-align:unset;
    margin-top: 20%;
  }
  .full-height {
    height: 900px!important;
    width: 100%;
  }
  .width-8 {
    padding-left: unset;
    padding-right: unset;
  }
  .m2-content-main {
    width: 85%;
    left: 7%;
    bottom: 13%;
  }
}
@media (max-width: 600px) {
  .intro-txt {
    text-align: left;
  }
  .m2-content-main {
    width: 100%!important;
    left: 0!important;
    bottom: 50px;
  }
}
@media (max-height:750px) {
  .m2-content-title {
    margin-top: 10px;
  }
  .m2-content-main {
    bottom: 15px;
    width: 82%;
    left: 11%;
  }
.m2-content-txt-1 {
  font-size: 12px;
  letter-spacing: unset;
}
.m2-content-txt-2 {
  font-size: 12px;
  letter-spacing: unset;
}
}

</style>